const handleOnUnloadEvent = (event) => {
  event.preventDefault();
  event.returnValue = '';
}

export default handleOnUnloadEvent;
